"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.66663 3.83333C1.66663 3.36662 1.66663 3.13327 1.75745 2.95501C1.83735 2.79821 1.96483 2.67072 2.12163 2.59083C2.29989 2.5 2.53325 2.5 2.99995 2.5H16.9999C17.4666 2.5 17.7 2.5 17.8782 2.59083C18.035 2.67072 18.1625 2.79821 18.2424 2.95501C18.3332 3.13327 18.3332 3.36662 18.3332 3.83333V4.39116C18.3332 4.61515 18.3332 4.72715 18.3059 4.83129C18.2816 4.92358 18.2417 5.01102 18.1878 5.08979C18.1271 5.17868 18.0424 5.25204 17.8731 5.39874L12.5434 10.0179C12.3741 10.1646 12.2894 10.2379 12.2287 10.3268C12.1748 10.4056 12.1349 10.4931 12.1106 10.5853C12.0833 10.6895 12.0833 10.8015 12.0833 11.0255V15.3819C12.0833 15.5449 12.0833 15.6264 12.057 15.6968C12.0338 15.7591 11.996 15.8149 11.9468 15.8596C11.8912 15.9101 11.8155 15.9404 11.6642 16.0009L8.83086 17.1342C8.52458 17.2568 8.37143 17.318 8.2485 17.2925C8.14099 17.2701 8.04665 17.2063 7.98598 17.1147C7.91661 17.0101 7.91661 16.8451 7.91661 16.5153V11.0255C7.91661 10.8015 7.91661 10.6895 7.88923 10.5853C7.86498 10.4931 7.82505 10.4056 7.7712 10.3268C7.71042 10.2379 7.62579 10.1646 7.45651 10.0179L2.12672 5.39874C1.95745 5.25204 1.87281 5.17868 1.81204 5.08979C1.75818 5.01102 1.71825 4.92358 1.694 4.83129C1.66663 4.72715 1.66663 4.61515 1.66663 4.39116V3.83333Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;